import React, { useState } from 'react';

const ImageLoader = ({ src, alt, fallback, className, style, overlay, ...props }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
    console.log('✅ Image chargée avec succès:', src);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
    console.error('❌ Erreur de chargement image:', src);
  };

  // Si l'image a échoué à charger, afficher le fallback
  if (imageError) {
    return (
      <div 
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(45deg, var(--color-accent), var(--color-secondary))',
          color: 'white',
          fontSize: '2rem',
          borderRadius: '12px'
        }}
        {...props}
      >
        {fallback}
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          ...style,
          opacity: imageLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease',
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
        {...props}
      />
      {/* Overlay supprimé : aucune superposition grise */}
    </div>
  );
};

export default ImageLoader; 